define('CoreChargeItem.View', [
    'SCView',
    'core_charge_item_view.tpl',
    'underscore'
], function ACSCoreChargeItemView(
    SCViewComponent,
    coreChargeItemTpl,
    _
) {
    'use strict';

    var SCView = SCViewComponent.SCView;
    function CoreChargeItemView(options) {
        SCView.call(this);
        this.options = options || {};
        this.template = coreChargeItemTpl;
        this.attributes = { id: 'CoreChargeItem.View' };
        this.contextDataRequest = ['item'];
    }
    CoreChargeItemView.prototype = _.extend(Object.create(SCView.prototype), {
        constructor: CoreChargeItemView,

        getContext: function getContext() {
            var itemInfo = this.contextData.item && this.contextData.item();
			var coreChargeItem = itemInfo && itemInfo.custitem_corechargeitem;
			// console.log('itemInfo', itemInfo)
            return {
                showCoreCharge: !_.isEmpty(coreChargeItem),
				coreChargeItem: coreChargeItem,
				isPLP: this.options.source === 'PLP'
            };
        }
    });
    return CoreChargeItemView;
});
